const hexToRgb = (hex: string): [number, number, number] | null => {
    let h = hex.replace('#', '');
    if (h.length === 3) {
        h = h
            .split('')
            .map((c) => c + c)
            .join('');
    }
    if (h.length !== 6) return null;
    const n = Number.parseInt(h, 16);
    if (Number.isNaN(n)) return null;
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
};

const perceivedLuminance = (r: number, g: number, b: number): number =>
    (0.299 * r + 0.587 * g + 0.114 * b) / 255;

/** Perceived luminance (0 = black, 1 = white) of a hex / `rgb()` / `white` / `black` colour. */
const luminanceOf = (color: string): number | null => {
    const c = color.trim().toLowerCase();
    if (c === 'white') return 1;
    if (c === 'black') return 0;
    const rgbMatch = c.match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/);
    if (rgbMatch) {
        return perceivedLuminance(
            Number(rgbMatch[1]),
            Number(rgbMatch[2]),
            Number(rgbMatch[3]),
        );
    }
    const rgb = c.startsWith('#') ? hexToRgb(c) : null;
    if (!rgb) return null;
    return perceivedLuminance(rgb[0], rgb[1], rgb[2]);
};

/**
 * Hairline border colour for a logo badge so a near-white logo on a white
 * background (or a near-black logo on a dark background) doesn't blend in:
 * a dark line on light fills, a light line on dark fills. Brand colours that
 * already stand out — and colours we can't parse — get no border.
 */
export const getLogoBadgeBorderColor = (
    background: string | null | undefined,
): string | undefined => {
    const lum = luminanceOf(background || 'white');
    if (lum === null) return undefined;
    if (lum >= 0.85) return '#333333';
    if (lum <= 0.15) return '#cccccc';
    return undefined;
};
